module.exports = __webpack_public_path__ + "static/img/002.43c45e1c.png";